import { exclusiveTopics } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import { showToast } from "@/hooks/useToast";

export default function ExclusiveGrid() {
  return (
    <section id="exclusive" className="scroll-mt-24 border-y border-background-200/80 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <Reveal className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-widest text-primary-600">EXCLUSIVE FILES</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              独家议题 · 本期开放阅读
            </h2>
          </div>
          <button
            type="button"
            onClick={() => showToast("更多独家议题正在整理中，稍后上新")}
            className="flex w-fit items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap"
          >
            查看往期合辑
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </button>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
          {exclusiveTopics.map((topic, index) => (
            <Reveal key={topic.title} delay={(index % 4) * 70}>
              <article className="group flex h-full flex-col rounded-lg border border-background-300/70 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 md:p-5">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{topic.category}</span>
                  <span className="font-heading text-xs tabular-nums text-background-500">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-heading mt-3 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[17px]">
                  {topic.title}
                </h3>
                <p className="mt-2.5 flex-1 text-[13px] leading-relaxed text-foreground-600">
                  {topic.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>{topic.duration}</span>
                  <span className="flex items-center gap-1">
                    {topic.updated}
                    <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-500">
                      <i className="ri-arrow-right-s-line" aria-hidden="true" />
                    </span>
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}